import {Section} from '@dms/shared';

import {CustomerInquiry} from './components/CustomerInquiry';

interface ServiceRequestProps {
  interestId: string;
}

export function ServiceRequest(props: ServiceRequestProps) {
  return (
    <Section>
      <CustomerInquiry
        interestId={props.interestId}
        data-testid="workshop-interest-serviceRequest"
      />
    </Section>
  );
}
